var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.74907H4.5C3.25736 3.74907 2.25 4.75643 2.25 5.99907V19.4991C2.25 20.7417 3.25736 21.7491 4.5 21.7491H19.5C20.7426 21.7491 21.75 20.7417 21.75 19.4991V5.99907C21.75 4.75643 20.7426 3.74907 19.5 3.74907Z",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50006 8.00029H21.7484",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 11.999C14.4962 11.999 14.9999 11.4953 14.9999 10.874C14.9999 10.2527 14.4962 9.74902 13.8749 9.74902C13.2536 9.74902 12.7499 10.2527 12.7499 10.874C12.7499 11.4953 13.2536 11.999 13.8749 11.999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6249 11.999C18.2463 11.999 18.7499 11.4953 18.7499 10.874C18.7499 10.2527 18.2463 9.74902 17.6249 9.74902C17.0036 9.74902 16.4999 10.2527 16.4999 10.874C16.4999 11.4953 17.0036 11.999 17.6249 11.999Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 15.7483C14.4962 15.7483 14.9999 15.2446 14.9999 14.6233C14.9999 14.002 14.4962 13.4983 13.8749 13.4983C13.2536 13.4983 12.7499 14.002 12.7499 14.6233C12.7499 15.2446 13.2536 15.7483 13.8749 15.7483Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6249 15.7483C18.2463 15.7483 18.7499 15.2446 18.7499 14.6233C18.7499 14.002 18.2463 13.4983 17.6249 13.4983C17.0036 13.4983 16.4999 14.002 16.4999 14.6233C16.4999 15.2446 17.0036 15.7483 17.6249 15.7483Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37494 15.7483C6.99626 15.7483 7.49994 15.2446 7.49994 14.6233C7.49994 14.002 6.99626 13.4983 6.37494 13.4983C5.75362 13.4983 5.24994 14.002 5.24994 14.6233C5.24994 15.2446 5.75362 15.7483 6.37494 15.7483Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1249 15.7483C10.7463 15.7483 11.2499 15.2446 11.2499 14.6233C11.2499 14.002 10.7463 13.4983 10.1249 13.4983C9.50362 13.4983 8.99994 14.002 8.99994 14.6233C8.99994 15.2446 9.50362 15.7483 10.1249 15.7483Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37494 19.4991C6.99626 19.4991 7.49994 18.9954 7.49994 18.3741C7.49994 17.7528 6.99626 17.2491 6.37494 17.2491C5.75362 17.2491 5.24994 17.7528 5.24994 18.3741C5.24994 18.9954 5.75362 19.4991 6.37494 19.4991Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1249 19.4991C10.7463 19.4991 11.2499 18.9954 11.2499 18.3741C11.2499 17.7528 10.7463 17.2491 10.1249 17.2491C9.50362 17.2491 8.99994 17.7528 8.99994 18.3741C8.99994 18.9954 9.50362 19.4991 10.1249 19.4991Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 19.4991C14.4962 19.4991 14.9999 18.9954 14.9999 18.3741C14.9999 17.7528 14.4962 17.2491 13.8749 17.2491C13.2536 17.2491 12.7499 17.7528 12.7499 18.3741C12.7499 18.9954 13.2536 19.4991 13.8749 19.4991Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99982 2.24895V3.74895",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 2.24895V3.74895",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.502e5cbb9d16192933ac58428e09c907.svg";
export { ForwardRef as ReactComponent };